import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { CommonService } from '../services/common.service'
import { AuthenticationService } from '../services/authentication.service'

@Injectable({
  providedIn: 'root'
})
export class PostsService {

    constructor(private http: HttpClient, private common: CommonService, private authentication: AuthenticationService) { }

    getPostById(postId: any, userId: any) {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Posts/getPostById?userId=' + userId + '&Id=' + postId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }


    getUserNewsFeedPosts(page: any, userId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Posts/getUserNewsFeedPosts?userId=' + userId + '&page=' + page, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    getUserPosts(page: any, userId: any, relatedTo: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Posts/getUserPosts?relatedTo=' + relatedTo + '&userId=' + userId + '&page=' + page, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    getModulePosts(page: any, userId: any, relatedTo: any, relatedId: any): any {
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Posts/getModulePosts?pageSize=1&relatedId=' + relatedId + '&relatedTo=' + relatedTo + '&userId=' + userId + '&page=' + page, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    addToUserPost(postData: any): any {

        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.post(this.common.apiServiceURL + 'Posts/addPost', postData, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    sendPostReply(reply: any, postId: any, userId: any): any {
        let replyData: any = {
            User_Id: userId,
            body: reply,
            liked: false,
            Posts_PostId: postId
        };
        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.post(this.common.apiServiceURL + 'Posts/postComment', replyData, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

    updatePostReply(reply: any): any {

        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.post(this.common.apiServiceURL + 'Posts/updatePostReply', reply, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }
    deletePostReply(reply: any): any {

        let _authorizationData = this.authentication._authentication;
        let token = _authorizationData.token;
        return this.http.get(this.common.apiServiceURL + 'Posts/deletePostReply?replyId=' + reply.postReplyId, {
            headers: new HttpHeaders({
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            })
        });
    }

}
